function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.75,
  cy: 40,
  r: 40,
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.75,
  cy: 40,
  r: 40,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 -14.9768L80.75 -15L80.7442 11.6929C78.3171 14.9945 74.2472 16.3875 68.5343 15.8719C59.9649 15.0988 44.9198 8.13749 27.9438 8.13749C16.6264 8.13749 7.56184 11.8028 0.75 19.1333V-14.9768Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M39.0925 43.7218L52.6155 30.1988L52.5769 30.0703C52.4729 29.7223 52.492 29.3579 52.6329 29.017L54.3475 24.8672C54.6729 24.0806 55.4342 23.5721 56.2889 23.5721C56.844 23.5721 57.3675 23.7899 57.7635 24.1859L58.196 24.6188L59.632 23.1823C59.8751 22.9392 60.2991 22.9392 60.5422 23.1823C60.7933 23.4334 60.7933 23.8419 60.5422 24.093L59.1062 25.529L59.5391 25.9614C60.0346 26.457 60.2488 27.1632 60.112 27.8512C59.9746 28.5388 59.5062 29.1094 58.8577 29.377L54.708 31.0916C54.5111 31.173 54.3071 31.2143 54.1026 31.2143C53.952 31.2143 53.8013 31.1921 53.6546 31.1481L53.5262 31.1094L40.0027 44.6321C39.7591 44.8756 39.3351 44.8747 39.0925 44.6321C38.9707 44.5103 38.9036 44.3489 38.9036 44.1769C38.9036 44.0054 38.9707 43.8436 39.0925 43.7218Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M54.8217 33.1628C60.2568 40.6912 59.4332 50.9236 52.8635 57.4934C49.3128 61.0441 44.5839 62.9996 39.5475 63.0001C39.5471 63.0001 39.5462 63.0001 39.5457 63.0001C34.0866 63.0001 28.8995 60.6334 25.312 56.5072C19.3427 49.6401 19.2169 39.1859 25.0204 32.1912C28.6244 27.8473 33.9182 25.3557 39.5448 25.3557C43.5386 25.3557 47.3493 26.5833 50.5639 28.9046C50.7217 29.0184 50.8208 29.1939 50.8359 29.3859C50.8515 29.5761 50.7857 29.7553 50.651 29.8899C50.4279 30.1126 50.0626 30.1339 49.8039 29.9473C46.8093 27.7859 43.2604 26.6433 39.5417 26.6433C34.5155 26.6433 29.7213 28.8046 26.3884 32.573C20.5569 39.1659 20.5396 49.1241 26.348 55.7361C29.6844 59.5338 34.4955 61.7129 39.5475 61.7129C39.5475 61.7129 39.5484 61.7129 39.5488 61.7129C44.2395 61.7134 48.6444 59.8912 51.9532 56.5827C58.071 50.465 58.8386 40.9339 53.7777 33.9206C53.5857 33.6548 53.6092 33.2992 53.8328 33.0757C53.9555 32.9535 54.1155 32.8868 54.2857 32.8868C54.4963 32.8868 54.6972 32.9899 54.8217 33.1628Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M51.242 36.78C54.6717 42.2004 53.8686 49.4266 49.3331 53.9626C46.7233 56.5723 43.2482 58.0092 39.5478 58.0092C35.5554 58.0092 31.7554 56.2848 29.122 53.2786C24.7389 48.2733 24.5967 40.6168 28.7909 35.4684C31.442 32.2133 35.3616 30.3462 39.5442 30.3462C42.1767 30.3462 44.7353 31.0849 46.9433 32.4822C47.1095 32.5871 47.2175 32.76 47.2398 32.9564C47.2615 33.1533 47.194 33.3462 47.0549 33.4857C46.838 33.7026 46.5029 33.7422 46.2664 33.592C44.2553 32.3146 41.9256 31.6395 39.5287 31.6395C36.1411 31.6395 32.97 32.9662 30.5994 35.3755C26.2003 39.8471 26.0052 47.8644 30.1816 52.5332C32.5634 55.1955 35.9767 56.7226 39.5473 56.7226C42.9038 56.7226 46.0549 55.419 48.422 53.0519C52.5371 48.9368 53.2571 42.3795 50.134 37.4604C49.9798 37.2173 50.0207 36.888 50.2313 36.6768C50.3598 36.5484 50.5224 36.4808 50.6953 36.4808C50.9193 36.4808 51.1233 36.5924 51.242 36.78Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M47.0225 40.1575C47.2732 40.1575 47.4905 40.2935 47.5901 40.513C49.1101 43.8566 48.3919 47.8423 45.8017 50.4321C44.1337 52.1001 41.9123 53.0183 39.547 53.0183C37.059 53.0183 34.6719 51.9632 32.9977 50.1223C29.9341 46.7548 29.9617 41.5014 33.0599 38.1641C34.7506 36.3432 37.0506 35.3406 39.5368 35.3406C40.8003 35.3406 42.0217 35.6015 43.1683 36.1148C43.3719 36.2059 43.5119 36.3828 43.5514 36.5997C43.5901 36.8086 43.5257 37.0143 43.375 37.165C43.1914 37.3481 42.9043 37.4063 42.6772 37.3037C41.7012 36.8601 40.6163 36.6259 39.5394 36.6259C37.3746 36.6259 35.3106 37.557 33.8764 39.1797C31.3492 42.0401 31.3959 46.4814 33.9826 49.2916C35.4106 50.8419 37.4386 51.7312 39.547 51.7312C41.5683 51.7312 43.4661 50.9463 44.8914 49.521C47.1048 47.3077 47.719 43.9019 46.4194 41.045C46.3154 40.8161 46.3714 40.5361 46.5594 40.3486C46.683 40.2255 46.8474 40.1575 47.0225 40.1575Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M41.9396 45.0756C41.9809 44.9623 42.0329 44.8756 42.0996 44.8094C42.2596 44.6494 42.4338 44.6161 42.5516 44.6161C42.7711 44.6161 42.9858 44.7263 43.1125 44.9041C43.192 45.0156 43.2685 45.2001 43.1831 45.4472C42.992 45.9983 42.6858 46.4872 42.2716 46.901C41.5449 47.6276 40.5783 48.0272 39.5476 48.0272C38.2405 48.0272 37.0672 47.397 36.3281 46.2974C35.4592 45.005 35.4907 43.2156 36.4054 41.9454C36.8663 41.305 37.4929 40.8268 38.2178 40.5628C38.5663 40.4357 38.9227 40.6037 39.0592 40.9334C39.1076 41.0503 39.1898 41.3508 38.9129 41.6281C38.8485 41.6921 38.7609 41.745 38.6534 41.7841C38.0316 42.0099 37.5476 42.4432 37.2529 43.0383C36.8489 43.8534 36.9103 44.8574 37.4085 45.5956C37.8916 46.313 38.6916 46.7414 39.5472 46.7414C40.2329 46.7414 40.8769 46.4747 41.3605 45.9912C41.616 45.7356 41.8103 45.4276 41.9396 45.0756Z",
  fill: "black"
});

var SvgPlanner = function SvgPlanner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 80
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -15,
    width: 81,
    height: 35
  }, _ref4), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 13.4673V18.4614L40.75 15.9644L0.75 13.4673Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8058 15.9268L40.8156 15.9189L40.7979 15.9207L40.7917 15.9251L40.8058 15.9268Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9001 15.9324L80.75 18.4197V13.4275L41.0245 15.9058L40.9001 15.9324Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7836 15.9254L40.7873 15.9209L40.7766 15.9218L40.7749 15.9245L40.7836 15.9254Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.758 15.9224H40.7527V15.9243H40.758V15.9224Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8506 15.9298L40.8958 15.9138L40.8408 15.9172L40.8203 15.9279L40.8506 15.9298Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7677 15.9199H40.7651V15.927H40.7677V15.9199Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 24.4789V29.831L40.75 15.9644L0.75 24.4789Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 15.9642L40.9002 15.9322L40.8505 15.9297L40.75 15.9642Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0244 15.9057L80.75 7.44978V2.09863L40.8958 15.9138L41.0244 15.9057Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8958 15.9139L40.8503 15.9299L40.9 15.9324L41.0244 15.9058L40.8958 15.9139Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8946 31.6591L40.75 15.9644L10.5713 31.6591H17.8946Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8406 15.917L80.75 -4.83837V-11.5034L40.8157 15.919L40.8406 15.917Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8059 15.927L40.75 15.9643L40.8202 15.9279L40.8059 15.927Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8202 15.9279L40.8407 15.9172L40.816 15.9192L40.8062 15.9271L40.8202 15.9279Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3685 31.6591L40.7501 15.9644L23.7344 31.6591H27.3685Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.798 15.9207L80.75 -20.9293V-25.6392H76.2224L40.7874 15.9207H40.798Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7837 15.9253L40.75 15.9643L40.7918 15.9253H40.7837Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7918 15.9254L40.798 15.9209H40.7873L40.7837 15.9254H40.7918Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2054 31.6591L40.7499 15.9644L30.7866 31.6591H33.2054Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7766 15.9215L67.1586 -25.6392H60.7523L40.7695 15.9215H40.7766Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7686 15.9243L40.75 15.9642L40.775 15.9243H40.7686Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7747 15.9199H40.7712V15.927H40.7747V15.9199Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6613 31.6591L40.75 15.9644L35.7202 31.6591H37.6613Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7631 15.9224L54.0835 -25.6392H48.9366L40.7578 15.9224H40.7631Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7579 15.9243L40.75 15.9642L40.7632 15.9243H40.7579Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7615 15.9209H40.7598V15.9262H40.7615V15.9209Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6571 31.6591L40.75 15.9644L39.844 31.6591H41.6571Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7525 15.9243L40.7499 15.9235L40.7525 15.9224L43.1502 -25.6392H38.3506L40.7499 15.9642L40.7525 15.9243Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 15.9234L40.7524 15.9242V15.9224L40.75 15.9234Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7806 31.6591L40.75 15.9644L43.8386 31.6591H45.7806Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5641 -25.6392H27.4172L40.7499 15.9642L32.5641 -25.6392Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7125 31.6591L40.75 15.9644L48.2954 31.6591H50.7125Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7496 -25.6392H14.3413L40.7501 15.9642L20.7496 -25.6392Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7665 31.6591L40.75 15.9644L54.1307 31.6591H57.7665Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27774 -25.6392H0.75V-20.9302L40.75 15.9642L5.27774 -25.6392Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9279 31.6591L40.75 15.9644L63.6055 31.6591H70.9279Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 -11.5034V-4.83837L40.75 15.9642L0.75 -11.5034Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75 29.831V24.4789L40.75 15.9644L80.75 29.831Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2.09766V7.44968L40.75 15.9642L0.75 2.09766Z",
    style: {
      fill: "var(--color-primary)"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 39.6499,
    cy: 43.8999,
    r: 8.5,
    style: {
      fill: "var(--color-primary)"
    }
  }), _ref5, _ref6, _ref7, _ref8, _ref9));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlanner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/planner.6b65e4c2.svg";
export { ForwardRef as ReactComponent };